'use strict';
var InputStream = (function () {
    function InputStream() {
    }
    InputStream.prototype.close = function () {
    };
    return InputStream;
}());
exports.InputStream = InputStream;
//# sourceMappingURL=InputStream.js.map